import React from 'react';

import styles from './LoadingSpinner.module.css';

export interface LoadingSpinnerProps {
    size?: 'small' | 'medium' | 'large';
    color?: 'primary' | 'secondary' | 'white';
    fullScreen?: boolean;
    text?: string;
    className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 'medium',
    color = 'primary',
    fullScreen = false,
    text = '',
    className = ''
}) => {
    const spinnerClasses = [
        styles.spinner,
        styles[size],
        styles[color],
        className
    ].filter(Boolean).join(' ');

    const content = (
        <div className={styles.spinnerContainer} role="progressbar" data-testid="loading">
            <div className={spinnerClasses}></div>
            {text && <p className={styles.text}>{text}</p>}
        </div>
    );

    if (fullScreen) {
        return (
            <div className={styles.fullScreen}>
                {content}
            </div>
        );
    }

    return content;
};

export default LoadingSpinner;
